import { Outlet } from 'react-router';
import { Footer } from './Footer';
import { Header } from './Header';
import { ExpiryBanner } from './ExpiryBanner';
import { ExpiryLoginModal } from './ExpiryLoginModal';

export function AppLayout() {
  return (
    <>
      <Header />
      <div className="pt-14">
        <ExpiryBanner />
        <Outlet />
      </div>
      <ExpiryLoginModal />
      <Footer />
    </>
  );
}
